var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"list"},_vm._l((_vm.sendVal),function(item,index){return _c('div',{key:index,staticClass:"my-list"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":item.image,"alt":""}}),_c('div',{staticClass:"my-uname p_line"},[_vm._v(" "+_vm._s(item.tital)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }